export const mobileAppEs = {
  mobileAppPage: {
    title: "App Móvil - Próxima Fase",
    subtitle: "Aplicación móvil nativa con capacidades offline, notificaciones en tiempo real y experiencia optimizada para campo (disponible en la siguiente fase del proyecto)",
    nextPhase: "Próxima Fase",
    iosRating: "Valoración iOS",
    androidRating: "Valoración Android",
    downloads: "Descargas",
    activeUsers: "Usuarios Activos",
    downloadTitle: "Descargar Sentinel Crop Mobile",
    iosAppStore: "iOS App Store",
    googlePlay: "Google Play",
    versionFeatures: "Características de la versión {{platform}}:",
    fullOffline: "Funcionalidad offline completa",
    cameraScan: "Escaneo de cultivos con cámara",
    gpsMapping: "Mapeo de campo por GPS",
    pushNotifications: "Notificaciones push",
    biometricAuth: "Autenticación biométrica",
    appleWatch: "App complementaria Apple Watch",
    androidWidgets: "Widgets Android para entrada rápida de datos",
    downloadFor: "Descargar para {{platform}}",
    mobilePreview: "Vista Previa de la App",
    liveDemo: "Demo en Vivo",
    tryDemo: "Probar Demo Interactiva",
    appFeatures: "Características",
    mobileWorkflow: "Flujo de Trabajo Móvil",
    technicalSpecs: "Especificaciones Técnicas",
    planned: "Planificado",
    cropHealthScanner: "Escáner de Salud de Cultivos",
    cropHealthScannerDesc: "Escanea cultivos con detección de enfermedades por IA usando la cámara del dispositivo",
    gpsFieldMapping: "Mapeo de Campo GPS",
    gpsFieldMappingDesc: "Mapeo preciso de parcelas y detección de límites usando GPS",
    realTimeAlerts: "Alertas en Tiempo Real",
    realTimeAlertsDesc: "Notificaciones push para avisos meteorológicos y reclamaciones de seguros",
    offlineMode: "Modo Offline",
    offlineModeDesc: "Accede a datos y funciones críticas sin conectividad a internet",
    voiceCommands: "Comandos de Voz",
    voiceCommandsDesc: "Entrada de datos y grabación de campo activada por voz",
    dataSync: "Sincronización de Datos",
    dataSyncDesc: "Sincronización fluida con la plataforma web cuando hay conexión",
    fieldDataCollection: "Recolección de Datos en Campo",
    fieldDataCollectionDesc: "Captura fotos, coordenadas GPS y observaciones de campo directamente desde tu dispositivo móvil",
    offlineDataStorage: "Almacenamiento Offline",
    offlineDataStorageDesc: "Todos los datos se almacenan localmente sin conexión, asegurando que no se pierda información crítica",
    automaticSync: "Sincronización Automática",
    automaticSyncDesc: "Cuando la conectividad vuelve, los datos se sincronizan automáticamente con la plataforma en la nube",
    realTimeAnalysis: "Análisis en Tiempo Real",
    realTimeAnalysisDesc: "Recibe información y recomendaciones instantáneas impulsadas por IA en tu dispositivo móvil",
    iosRequirements: "Requisitos iOS",
    androidRequirements: "Requisitos Android",
    minimumVersion: "Versión mínima de {{platform}}:",
    compatibleDevices: "Dispositivos compatibles:",
    ramRequired: "RAM requerida:",
    storageRequired: "Almacenamiento requerido:",
    languages: "Idiomas:",
    offlineStorage: "Almacenamiento offline:",
    developmentStack: "Stack de Desarrollo",
    mobileFramework: "Framework Móvil",
    keyTechnologies: "Tecnologías Clave",
    comingNextPhase: "Disponible en la Próxima Fase",
    comingNextPhaseDesc: "La aplicación móvil estará disponible en la próxima fase del proyecto. Mientras tanto, puedes acceder a todas las funciones desde nuestra plataforma web.",
    iosAppNextPhase: "iOS App (Próxima Fase)",
    androidAppNextPhase: "Android App (Próxima Fase)",
    accessWebPlatform: "Acceder a Plataforma Web"
  }
};